const INITIAL_STATE = {
  modoTela: "lista",
  lista: [],
  horarioAtual: null,
  relatorio: [],
};

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case "SOLICITACAO_HORA_EXTRA_MODO_TELA":
      return {
        ...state,
        modoTela: action.payload.modo,
      };
    case "SOLICITACAO_HORA_EXTRA_LISTADO":
      return {
        ...state,
        lista: action.payload.data,
      };
    case "HORARIO_ATUAL_LISTADO":
      return {
        ...state,
        ...action.payload.data,
      };

    case "SOLICITACAO_RELATORIO":
      return {
        ...state,
        relatorio: action.payload.data,
      };

    default:
      return state;
  }
};
